export default __webpack_public_path__ + "static/media/generic.76cecdfd.jpg";